import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  login as loginService,
  logout as logoutService,
} from '../services/user';

export function useUser() {
  const [user, setUser] = useState(null);
  const [refreshState, setRefreshState] = useState(false);

  const navigate = useNavigate();

  const logOut = (user) => {
    logoutService(user).then(async () => {
      localStorage.clear();
      setUser(false);
      navigate('/');
    });
  };

  const logIn = (user) =>
    loginService(user).then((data) => {
      localStorage.setItem('token', data?.data?.token);
      localStorage.setItem('name', data?.data?.user?.full_name);
      localStorage.setItem('email', data?.data?.user?.email);
      localStorage.setItem(
        'permissions',
        JSON.stringify(data?.data?.user?.role[0]?.permissions)
      );
      navigate('/');
      return user;
    });

  const isAuth = localStorage.getItem('token');

  useEffect(() => {
    if (isAuth?.length > 0) {
      setUser(true);
    } else {
      setUser(false);
    }

    return () => {
      setUser(null);
    };
  }, [refreshState, isAuth]);

  const refreshUser = () => {
    setRefreshState(!refreshState);
  };

  return { user, logOut, logIn, refreshUser };
}
